

































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { generateSourceCode, GeneratorConfig } from './codegen';

import ConfigPanel from './components/ConfigPanel.vue';

@Component({
  components: {
    ConfigPanel,
  },
})
export default class App extends Vue {
  private config: GeneratorConfig = {
    packageName: 'main',
    funcPrefix: 'MyStruct',
    funcSuffix: '',
    sliceType: '*MyStruct',
    acceptLessThan: true,
    useTimSort: false,
  };

  private goCode(): string {
    return generateSourceCode(this.config);
  }

  private updated() {
    const elem = document.getElementById('goCode') as HTMLElement;
    elem.innerHTML = this.escapeHtml(this.goCode());
    const win = window as any;
    win.Prism.highlightAll();
  }

  private escapeHtml(content: string) {
    return content
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
